import React from 'react';
import { DEPARTMENTS } from '../utils/constants';

const DepartmentFilter = ({ selectedDepartment, onDepartmentChange }) => {
  return (
    <div className="card p-4 mb-6">
      <div className="flex items-center space-x-4">
        <label className="text-sm font-medium text-gray-700">
          Filter by Department:
        </label>
        <select 
          value={selectedDepartment} 
          onChange={(e) => onDepartmentChange(e.target.value)}
          className="form-select w-48"
        >
          <option value="">All Departments</option>
          {DEPARTMENTS.map(dept => (
            <option key={dept} value={dept}>{dept}</option>
          ))}
        </select>
        
        {selectedDepartment && (
          <button
            onClick={() => onDepartmentChange('')}
            className="text-sm text-gray-600 hover:text-gray-800"
          >
            Clear Filter
          </button>
        )}
      </div>
    </div>
  );
};

export default DepartmentFilter;